export default __webpack_public_path__ + "static/media/portfolio-9.0e1d71f2.jpg";